export default {
  name: 'lx-no-content',
}
